import { render } from "./PVContent.vue?vue&type=template&id=671a2a5c&scoped=true"
import script from "./PVContent.vue?vue&type=script&lang=js"
export * from "./PVContent.vue?vue&type=script&lang=js"

import "./PVContent.vue?vue&type=style&index=0&id=671a2a5c&scoped=true&lang=css"
import "./PVContent.vue?vue&type=style&index=1&id=671a2a5c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671a2a5c"]])

export default __exports__